import { createFileRoute } from '@tanstack/react-router';
import { ForeclosureList } from '../../../features/foreclosure/components/ForeclosureList';
import { PageHeader } from '../../../components/layout/PageHeader';
import { usePageTitle } from '../../../lib/hooks.js';

export const Route = createFileRoute('/_auth/foreclosure/')({
  component: ForeclosurePage,
});

function ForeclosurePage() {
  usePageTitle('Foreclosures');
  return (
    <div className="space-y-6">
      <PageHeader
        title="Foreclosure & Subscription Exit"
        subtitle="Manage Premature Exits, Settlement Calculations, and NOC Document Issuance"
      />
      <ForeclosureList />
    </div>
  );
}
